export const VSP_SURVEY_SOURCE_LIST = 'VSP_SURVEY_SOURCE_LIST';
export const VSP_SURVEY_SOURCE_LIST_SUCCESS = 'VSP_SURVEY_SOURCE_LIST_SUCCESS';
export const VSP_SURVEY_SOURCE_LIST_ERROR = 'VSP_SURVEY_SOURCE_LIST_ERROR';

export const VSP_SURVEY_SOURCE_UPDATE_DATA = 'VSP_SURVEY_SOURCE_UPDATE_DATA';